"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureProviderHelpers = void 0;
class CaptureProviderHelpers {
    static isCaptureProvider(c) {
        return typeof c.getCaptures === 'function';
    }
    static getCaptures(c) {
        const collections = [];
        c.forEachField((field) => {
            if (!CaptureProviderHelpers.isCaptureProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCaptures() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
    static getCaptureIds(c) {
        if (!c) {
            return [];
        }
        const collections = [];
        c.forEachField((field) => {
            if (!CaptureProviderHelpers.isCaptureProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCaptureIds() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
}
exports.CaptureProviderHelpers = CaptureProviderHelpers;
//# sourceMappingURL=capture.provider.js.map